import { PAYOUT_TYPES } from '@library/constants/promotions';
import type { PromotionPayoutType } from '@library/types/promotions';
import { Select } from '@library/components/selects';
import type { SelectOption } from '@library/types/utils';
import { formatLabelByKey } from '@bo-utils/common';
import { useMemo } from 'react';

export const PayoutTypeSelect = ({
  containerClassName = '',
  className = '',
  iconOnly = false,
  label = undefined,
  onChange,
  value,
  zIndex = undefined
}: {
  containerClassName?: string;
  className?: string;
  iconOnly?: boolean;
  label?: string;
  onChange: (payoutType: PromotionPayoutType) => void;
  value: PromotionPayoutType;
  zIndex?: number;
}) => {
  const payoutTypeValues = useMemo<SelectOption[]>(
    () =>
      PAYOUT_TYPES.map((payoutType) => ({
        key: payoutType,
        name: formatLabelByKey(payoutType, ['credit', 'promo']),
        value: payoutType
      })),
    []
  );

  const handleOnChange = (payoutTypeSelectOption: SelectOption) => {
    onChange(payoutTypeSelectOption.value as PromotionPayoutType);
  };

  return (
    <>
      {label && (
        <label className="text-soClean-100 rounded-md text-xs uppercase leading-6">
          {label}
        </label>
      )}
      <Select
        containerClassName={containerClassName}
        className={className}
        iconOnly={iconOnly}
        optionsClassName="!t-6"
        label={label!}
        onChange={handleOnChange}
        options={payoutTypeValues}
        size="small"
        testId="payout-types"
        value={value}
        zIndex={zIndex}
        portal
      />
    </>
  );
};
